/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import DialogActions from '@mui/material/DialogActions';
import Button from '../button';
import { StyledModal, StyledDialogTitle, StyledModalContent } from './__fixtures__';
import type { Props as ModalProps } from './__fixtures__/modal.types';

export default function Modal({
  onNegative,
  onPositive,
  disabled,
  positiveDisabled,
  negativeDisabled,
  serverError,
  onSubmit,
  minHeight,
  title,
  negative = 'Cancel',
  positive = 'Submit',
  hideActions,
  hideTitle,
  ...props
}: ModalProps) {
  return (
    <StyledModal {...props}>
      {!hideTitle && (
        <StyledDialogTitle
          legacyMode={props.legacyMode}
          data-testid="dialog-title"
          onClose={props.onClose}
        >
          {title}
        </StyledDialogTitle>
      )}
      <StyledModalContent
        sx={{ minHeight }}
        legacyMode={props.legacyMode}
        dividers={!props.legacyMode}
      >
        <form noValidate onSubmit={onSubmit} id="dialog-form">
          {props.children}
        </form>
      </StyledModalContent>
      {!hideActions && (
        <DialogActions>
          <Button
            disabled={negativeDisabled || disabled}
            onClick={onNegative}
            data-testid="dialog-cancel-button"
          >
            {negative}
          </Button>
          <Button
            color="secondary"
            form={onSubmit ? 'dialog-form' : undefined}
            type={onSubmit ? 'submit' : 'button'}
            disabled={positiveDisabled ?? disabled}
            onClick={onPositive}
            data-testid="test-positive-button"
          >
            {serverError ? 'Resubmit' : positive || 'Submit'}
          </Button>
        </DialogActions>
      )}
    </StyledModal>
  );
}
